import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Input, Switch, Button, Space, Row, Col, message } from 'antd';
import axios from 'axios';

const { Title, Paragraph } = Typography;

const BrandingWhiteLabel = () => {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();
  const [agencyId, setAgencyId] = useState(null);

  useEffect(() => {
    // Load existing white-label agency to populate branding settings
    (async () => {
      try {
        const { data } = await axios.get('/api/whitelabel-agencies?limit=1');
        const agency = data?.items?.[0];
        if (agency) {
          setAgencyId(agency.id);
          form.setFieldsValue({
            app_name: agency.name || '',
            custom_domain: agency.domain || '',
            logo_url: agency.logo_url || '',
          });
        }
      } catch (e) {
        message.error(e.response?.data?.error || 'Failed to load branding');
      }
    })();
  }, [form]);

  // Save branding to backend (maps supported fields only)
  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (!agencyId) {
        return message.info('No agency found to update. Create a WhiteLabel agency first.');
      }
      setSaving(true);
      const headers = {};
      const token = sessionStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;
      const payload = {
        name: values.app_name,
        domain: values.custom_domain,
        logo_url: values.logo_url || null,
      };
      const { data } = await axios.put(`/api/whitelabel-agencies/${agencyId}`, payload, { headers });
      // reflect saved values
      form.setFieldsValue({
        app_name: data.name || '',
        custom_domain: data.domain || '',
        logo_url: data.logo_url || '',
      });
      message.success('Branding settings saved');
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.response?.data?.error || 'Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Settings' },
        { title: 'Branding & White Label' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Branding & White Label</Title>
        <Space>
          <Button type="primary" onClick={onSubmit} loading={saving}>Save Settings</Button>
        </Space>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>
          Configure application branding, colors, and white-label options.
        </Paragraph>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item label="Application Name" name="app_name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Custom Domain" name="custom_domain">
                <Input placeholder="app.yourdomain.com" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Primary Color" name="primary_color" rules={[{ required: true }]}>
                <Input placeholder="#1677ff" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Secondary Color" name="secondary_color" rules={[{ required: true }]}>
                <Input placeholder="#13c2c2" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Logo URL" name="logo_url">
                <Input placeholder="https://.../logo.png" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Favicon URL" name="favicon_url">
                <Input placeholder="https://.../favicon.ico" />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item label="Enable White Label" name="white_label_enabled" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default BrandingWhiteLabel;
